// 生成唯一id
export const generateUniqueId = () => {
  return new Date().getTime().toString(36) + Math.random().toString(36).substr(2);
};

// 设置device_id
export const setDeviceId = function () {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = []; let i;
  for (i = 0; i < 16; i++) {
    uuid[i] = chars[0 | Math.random() * chars.length];
  };
  return uuid.join('');
};

export const formateSendData = (baseInfo = {}, event = []) => {
  const actions = JSON.stringify(event.map((item) => {
    console.log(item.info, '>>>>>info');
    return {
      ...item,
      info: JSON.stringify(item.info),
    };
  }));
  const data = {
    ...baseInfo,
    actions,
  };
  console.log(data, '>>>>>data');
  const spm_E = Date.now();
  const spm_A = data.OsName === 'Android' ? 'MiShop_A' : 'MiShop_I';
  return {
    events: [
      {
        xiaomi_id: data.xiaomi_id || '未知用户',
        client_time: spm_E,
        session: data.traceId || '',
        event_id: 1,
        event_type: 'YRN_INSPECT',
        utm: {
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
        },
        spm: `${spm_A}.0.0.0.${spm_E}`,
        spmref: `${spm_A}.0.0.0.${spm_E}`,
        scm: 'A.B.C.D.E.F.G.H',
        scmref: 'A.B.C.D.E.F.G.H',
        scmref_step: 1,
        uri: data.url || '',
        uriref: '',
        params: data,
      },
    ],
    specs: {
      device: data.deviceModel || '',
      os: data.os || '',
      app_version: data.appVersion || '',
    },
    // todo
    env: 'staging',
  };
};

export const noop = () => {};

// 生成xPath
export const getXPath = (element) => {
  // 处理 id 的情况
  if (element.id) {
    return `//*[@id="${element.id}"]`;
  }
  // 处理根元素
  if (element === document.documentElement) {
    return '/html';
  }

  // 获取同级元素中的位置
  const siblings = element.parentNode.children;
  const sameTagSiblings = Array.from(siblings).filter((sibling) => sibling.tagName === element.tagName);
  const index = sameTagSiblings.indexOf(element) + 1;

  // 获取父元素路径并拼接
  return `${getXPath(element.parentNode)}/${element.tagName.toLowerCase()}[${index}]`;
};

// 根据 xPath 查找元素
export const findElementByXPath = (xpath) => {
  try {
    return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
  } catch (error) {
    console.error('查找元素失败:', error);
    return null;
  }
};

export const getUrlPath = (url = '') => {
  try {
    const pathname = new URL(url).pathname;
    return pathname;
  } catch (error) {
    return url;
  }
};

export const getUrlQuery = (url = '') => {
  try {
    const searchParams = new URL(url).searchParams;
    return Object.fromEntries(searchParams.entries());
  } catch (error) {
    return {};
  }
};
